import { addStyles } from 'ethcss'
import { colors, IStyles } from 'theme'
import { color } from 'theme/tokens/color'

const styles: IStyles = {
    inputFieldContainer: {
        width: '100%',
    },
    label: {
        display: 'flex',
        marginBottom: 10,
        color: colors.blackLight,
    },
    required: {
        color: colors.error,
    },
    inputFieldWrapper: {
        width: '100%',
        overflow: 'hidden',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 5,
    },
    input: {
        width: '100%',
        padding: 10,
        border: 'none',

        '&::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
        },
        '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
        },
    },
    sample: {
        marginTop: 7,
        color: color.fontDarkMedium,
    },
}

addStyles(styles)
export default styles
